/*!
 * Ola! Otter Live Chat — store chat bubble
 * Add to Shopify: Online Store → Themes → Edit code → layout/theme.liquid, just before </body>:
 *
 *   <script src="{{ 'olaotter-chat.js' | asset_url }}" defer
 *           data-endpoint="https://script.google.com/macros/s/YOUR-DEPLOYMENT-ID/exec"
 *           data-color="#6b55b8"
 *           data-title="Ola! Otter"
 *           data-subtitle="We usually reply in a few minutes"></script>
 */
(function () {
  "use strict";
  if (window.__olaChatLoaded) return;
  window.__olaChatLoaded = true;

  var script = document.currentScript || document.querySelector("script[data-endpoint][src*='olaotter-chat']");
  var CFG = {
    endpoint: script && script.getAttribute("data-endpoint"),
    color: (script && script.getAttribute("data-color")) || "#6b55b8",
    title: (script && script.getAttribute("data-title")) || "Ola! Otter",
    subtitle: (script && script.getAttribute("data-subtitle")) || "We usually reply in a few minutes",
    greeting: (script && script.getAttribute("data-greeting")) ||
      "Hi there! 👋 Looking for something for your little one? Ask me about sizes, prints or materials.",
  };
  if (!CFG.endpoint) { console.warn("[Ola chat] data-endpoint missing"); return; }

  // ───────── state (persisted per browser) ─────────
  var KEY = "olaChat.v1";
  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function save() { try { localStorage.setItem(KEY, JSON.stringify(S)); } catch (e) {} }
  var S = load();
  if (!S.visitorId) { S.visitorId = "v_" + Math.random().toString(36).slice(2) + Date.now().toString(36); }
  S.messages = S.messages || []; // [{id, sender, body}]
  S.lastId = S.lastId || 0;
  save();

  var isOpen = false, sending = false, pollTimer = null, unread = 0, lastActivity = Date.now();

  function meta() {
    var lang = navigator.language || "";
    var region = (lang.split("-")[1] || "").toUpperCase();
    return {
      visitor_id: S.visitorId,
      page_url: location.href.split("#")[0].slice(0, 500),
      referrer: document.referrer.slice(0, 500),
      timezone: (Intl.DateTimeFormat().resolvedOptions().timeZone || ""),
      language: lang,
      country: region.length === 2 ? region : null,
    };
  }
  function api(action, extra) {
    var body = Object.assign({ action: action }, meta(), extra || {});
    if (S.conversationId) { body.conversation_id = S.conversationId; body.token = S.token; }
    // text/plain avoids a CORS preflight, which Google Apps Script doesn't answer.
    return fetch(CFG.endpoint, { method: "POST", headers: { "Content-Type": "text/plain;charset=utf-8" }, body: JSON.stringify(body), redirect: "follow" })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.error) throw new Error(d.error); return d; });
  }

  // ───────── UI (shadow DOM so the theme's CSS can't break it) ─────────
  var host = document.createElement("div");
  host.id = "ola-chat";
  var root = host.attachShadow ? host.attachShadow({ mode: "open" }) : host;
  root.innerHTML =
    "<style>" +
    ":host{all:initial}*{box-sizing:border-box;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif}" +
    ".btn{position:fixed;right:20px;bottom:20px;width:60px;height:60px;border-radius:50%;border:0;background:" + CFG.color + ";color:#fff;cursor:pointer;box-shadow:0 6px 20px rgba(0,0,0,.2);z-index:2147483000;display:flex;align-items:center;justify-content:center;transition:transform .15s}" +
    ".btn:hover{transform:scale(1.06)}.btn svg{width:28px;height:28px}" +
    ".badge{position:absolute;top:-2px;right:-2px;min-width:20px;height:20px;padding:0 6px;border-radius:10px;background:#e0453a;color:#fff;font-size:12px;font-weight:700;line-height:20px;text-align:center;display:none}" +
    ".panel{position:fixed;right:20px;bottom:92px;width:370px;max-width:calc(100vw - 24px);height:560px;max-height:calc(100vh - 120px);background:#fff;border-radius:16px;box-shadow:0 12px 40px rgba(0,0,0,.22);z-index:2147483000;display:none;flex-direction:column;overflow:hidden;color:#1f2933}" +
    ".panel.open{display:flex}" +
    ".head{background:" + CFG.color + ";color:#fff;padding:16px 16px 14px;display:flex;align-items:flex-start;gap:10px}" +
    ".head .t{font-weight:700;font-size:16px}.head .s{font-size:12.5px;opacity:.9;margin-top:2px}.head .grow{flex:1}" +
    ".x{background:transparent;border:0;color:#fff;font-size:22px;line-height:1;cursor:pointer;padding:0 2px}" +
    ".human{display:inline-block;margin-top:8px;background:rgba(255,255,255,.18);border:0;color:#fff;border-radius:999px;padding:5px 11px;font-size:12px;cursor:pointer}" +
    ".log{flex:1;overflow-y:auto;padding:14px;background:#f7f8f7;display:flex;flex-direction:column;gap:8px}" +
    ".m{max-width:82%;padding:9px 12px;border-radius:14px;font-size:14px;line-height:1.45;white-space:pre-wrap;word-wrap:break-word}" +
    ".m a{color:inherit;text-decoration:underline}" +
    ".m.visitor{align-self:flex-end;background:" + CFG.color + ";color:#fff;border-bottom-right-radius:4px}" +
    ".m.ai,.m.staff{align-self:flex-start;background:#fff;border:1px solid #e3e7e5;border-bottom-left-radius:4px}" +
    ".m.system{align-self:center;background:transparent;color:#66707a;font-size:12.5px;text-align:center;max-width:92%}" +
    ".who{font-size:11px;color:#7b858f;margin:2px 4px -4px}.who.r{align-self:flex-end}" +
    ".typing{align-self:flex-start;display:none;gap:4px;padding:12px;background:#fff;border:1px solid #e3e7e5;border-radius:14px}" +
    ".typing span{width:7px;height:7px;border-radius:50%;background:#9aa4ad;animation:b 1s infinite}.typing span:nth-child(2){animation-delay:.15s}.typing span:nth-child(3){animation-delay:.3s}" +
    "@keyframes b{0%,60%,100%{opacity:.3;transform:translateY(0)}30%{opacity:1;transform:translateY(-3px)}}" +
    ".card{align-self:stretch;background:#fff;border:1px solid #e3e7e5;border-radius:12px;padding:10px;font-size:13px}" +
    ".card input{width:100%;margin-top:6px;padding:8px 10px;border:1px solid #cfd6d3;border-radius:8px;font-size:13px}" +
    ".card .row{display:flex;gap:6px;margin-top:8px}.card button{flex:1;padding:8px;border-radius:8px;border:0;cursor:pointer;font-size:13px}" +
    ".card .ok{background:" + CFG.color + ";color:#fff}.card .skip{background:#eef1f0;color:#33404a}" +
    ".foot{display:flex;gap:8px;padding:10px;border-top:1px solid #e9ecea;background:#fff}" +
    ".foot textarea{flex:1;resize:none;border:1px solid #cfd6d3;border-radius:10px;padding:9px 11px;font-size:14px;height:42px;max-height:110px;outline:none}" +
    ".foot textarea:focus{border-color:" + CFG.color + "}" +
    ".send{border:0;background:" + CFG.color + ";color:#fff;border-radius:10px;width:44px;cursor:pointer}.send:disabled{opacity:.5;cursor:default}" +
    ".err{color:#b42318;font-size:12px;padding:0 12px 8px;display:none;background:#fff}" +
    "@media (max-width:480px){.panel{right:0;bottom:0;width:100vw;max-width:100vw;height:100%;max-height:100%;border-radius:0}.btn.hide{display:none}}" +
    "</style>" +
    "<button class='btn' aria-label='Chat with us'><svg viewBox='0 0 24 24' fill='currentColor'><path d='M12 3C6.5 3 2 6.9 2 11.7c0 2.4 1.1 4.6 3 6.2L4.3 21l3.8-1.9c1.2.4 2.5.6 3.9.6 5.5 0 10-3.9 10-8.7S17.5 3 12 3z'/></svg><span class='badge'></span></button>" +
    "<div class='panel' role='dialog' aria-label='Chat with Ola! Otter'>" +
    "  <div class='head'><div class='grow'><div class='t'></div><div class='s'></div><button class='human'>Talk to a person</button></div><button class='x' aria-label='Close chat'>×</button></div>" +
    "  <div class='log'><div class='typing'><span></span><span></span><span></span></div></div>" +
    "  <div class='err'></div>" +
    "  <div class='foot'><textarea placeholder='Type your message…' maxlength='1000' rows='1'></textarea><button class='send' aria-label='Send'>➤</button></div>" +
    "</div>";
  var $ = function (s) { return root.querySelector(s); };
  var btn = $(".btn"), badge = $(".badge"), panel = $(".panel"), log = $(".log"), typing = $(".typing"),
      input = $("textarea"), sendBtn = $(".send"), err = $(".err");
  $(".t").textContent = CFG.title;
  $(".s").textContent = CFG.subtitle;

  // Safe text with clickable links (no HTML injection).
  function fill(el, text) {
    var re = /(https?:\/\/[^\s<>"')]+)/g, last = 0, m;
    while ((m = re.exec(text))) {
      if (m.index > last) el.appendChild(document.createTextNode(text.slice(last, m.index)));
      var a = document.createElement("a");
      a.href = m[1]; a.textContent = m[1].replace(/^https?:\/\/(www\.)?/, "").replace(/\/$/, "");
      if (!/olaotter\.com/.test(m[1])) { a.target = "_blank"; a.rel = "noopener nofollow"; }
      el.appendChild(a); last = m.index + m[1].length;
    }
    if (last < text.length) el.appendChild(document.createTextNode(text.slice(last)));
  }
  var LABEL = { ai: "Ola! Otter assistant", staff: "Ola! Otter team" };
  var prevSender = null;
  function addBubble(sender, body) {
    if (sender !== "system" && sender !== prevSender) {
      var who = document.createElement("div");
      who.className = "who" + (sender === "visitor" ? " r" : "");
      who.textContent = sender === "visitor" ? "You" : LABEL[sender] || "";
      log.insertBefore(who, typing);
    }
    var el = document.createElement("div");
    el.className = "m " + sender;
    fill(el, body);
    log.insertBefore(el, typing);
    prevSender = sender;
    log.scrollTop = log.scrollHeight;
  }
  function render() {
    Array.prototype.slice.call(log.children).forEach(function (c) { if (c !== typing) log.removeChild(c); });
    prevSender = null;
    addBubble("ai", CFG.greeting);
    S.messages.forEach(function (m) { addBubble(m.sender, m.body); });
    if (S.conversationId && !S.emailAsked && S.messages.some(function (m) { return m.sender !== "visitor"; })) emailCard();
  }
  function ingest(list) {
    var added = 0;
    (list || []).forEach(function (m) {
      if (m.id <= S.lastId && S.messages.some(function (x) { return x.id === m.id; })) return;
      S.messages.push({ id: m.id, sender: m.sender, body: m.body });
      S.lastId = Math.max(S.lastId, m.id);
      addBubble(m.sender, m.body);
      if (m.sender !== "visitor") added++;
    });
    if (added) { save(); if (!isOpen) { unread += added; showBadge(); } }
    return added;
  }
  function showBadge() { badge.textContent = unread > 9 ? "9+" : String(unread); badge.style.display = unread ? "block" : "none"; }
  function showErr(t) { err.textContent = t || ""; err.style.display = t ? "block" : "none"; }

  function emailCard() {
    if ($(".card")) return;
    var c = document.createElement("div");
    c.className = "card";
    c.innerHTML = "Want us to follow up by email if you leave?<input type='text' placeholder='Your name (optional)' maxlength='100'><input type='email' placeholder='you@example.com' maxlength='200'><div class='row'><button class='skip'>No thanks</button><button class='ok'>Save</button></div>";
    var ins = c.querySelectorAll("input");
    c.querySelector(".skip").onclick = function () { S.emailAsked = true; save(); c.remove(); };
    c.querySelector(".ok").onclick = function () {
      var email = ins[1].value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { ins[1].style.borderColor = "#b42318"; return; }
      api("identify", { name: ins[0].value.trim(), email: email }).then(function () {
        S.emailAsked = true; save(); c.remove(); addBubble("system", "Thanks! We'll follow up at " + email + " if we miss you here.");
      }).catch(function () { showErr("Couldn't save your email. Please try again."); });
    };
    log.insertBefore(c, typing);
    log.scrollTop = log.scrollHeight;
  }

  // ───────── actions ─────────
  function send() {
    var text = input.value.trim();
    if (!text || sending) return;
    sending = true; sendBtn.disabled = true; showErr("");
    input.value = ""; autosize();
    addBubble("visitor", text);
    typing.style.display = "flex"; log.scrollTop = log.scrollHeight;
    lastActivity = Date.now();
    api("send", { body: text }).then(function (d) {
      S.conversationId = d.conversation_id; S.token = d.token;
      S.messages.push({ id: d.visitor_message_id, sender: "visitor", body: text });
      save();
      ingest(d.messages);
      if (!S.emailAsked && d.messages && d.messages.length) emailCard();
      schedulePoll();
    }).catch(function (e) {
      showErr(/limit/.test(e.message) ? "This chat has reached its message limit. Please email us instead." : "Message not sent — please check your connection and try again.");
      input.value = text;
    }).then(function () { sending = false; sendBtn.disabled = false; typing.style.display = "none"; input.focus(); });
  }
  function askHuman() {
    lastActivity = Date.now();
    api("handoff").then(function () {
      if (!S.conversationId) addBubble("system", "Sure! Type your question below and a team member will reply here.");
      poll();
    }).catch(function () {});
  }
  function poll() {
    if (!S.conversationId) return Promise.resolve();
    return api("poll", { after_id: S.lastId }).then(function (d) {
      if (d.mode === null) { S.conversationId = null; S.token = null; save(); return; } // chat no longer valid
      ingest(d.messages);
    }).catch(function () {});
  }
  function schedulePoll() {
    clearTimeout(pollTimer);
    if (!S.conversationId) return;
    var idle = Date.now() - lastActivity;
    if (idle > 30 * 60000) return; // stop after 30 min of inactivity; resumes when they interact
    pollTimer = setTimeout(function () { poll().then(schedulePoll); }, isOpen ? 3000 : 15000);
  }
  // open({ auto: true }) is used by the store's auto-open; it isn't counted as a visitor opening the chat.
  function open(opts) {
    if (isOpen) return;
    isOpen = true; panel.classList.add("open"); btn.classList.add("hide");
    unread = 0; showBadge(); lastActivity = Date.now();
    if (!(opts && opts.auto)) api("event", { event: "open" }).catch(function () {});
    if (!(opts && opts.auto)) setTimeout(function () { input.focus(); }, 50); // no surprise phone keyboard on auto-open
    poll().then(schedulePoll);
  }
  function close() {
    isOpen = false; panel.classList.remove("open"); btn.classList.remove("hide");
    api("event", { event: "close" }).catch(function () {});
    schedulePoll();
  }
  function autosize() { input.style.height = "42px"; input.style.height = Math.min(input.scrollHeight, 110) + "px"; }

  btn.onclick = function () { isOpen ? close() : open(); };
  $(".x").onclick = close;
  $(".human").onclick = askHuman;
  sendBtn.onclick = send;
  input.addEventListener("input", autosize);
  input.addEventListener("keydown", function (e) { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); } });

  function mount() {
    document.body.appendChild(host);
    render();
    if (S.conversationId) schedulePoll(); // keep them "live" + catch replies while browsing
  }
  if (document.body) mount(); else document.addEventListener("DOMContentLoaded", mount);

  // Let the store open the chat from any link/button: <a href="#chat" onclick="OlaChat.open()">
  window.OlaChat = { open: open, close: close };
})();
